import { withInstall } from '../../../../utils/with-install'
import Image from './Image.vue'

export const ElAmapLayerImage = withInstall(Image)
export default ElAmapLayerImage
